import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLibModule } from '@nrwl/common-lib';
import { TestSetupModule } from '@nrwl/test-setup';
import { CommonMaterialModule } from '@nrwl/common-material';
import { TruespeedTestSetupComponent } from './setup/truespeed-setup.component';
import { TruespeedSetupService } from './setup/truespeed-setup.service';
import { TruespeedSetupBasicTabComponent } from './setup/tabs/truespeed-setup-basic-tab/truespeed-setup-basic-tab.component';
import { TruespeedSetupAdvanceTabComponent } from './setup/tabs/truespeed-setup-advance-tab/truespeed-setup-advance-tab.component';

@NgModule({
  imports: [
    CommonModule,
    CommonLibModule,
    CommonMaterialModule,
    TestSetupModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    TruespeedTestSetupComponent,
    TruespeedSetupBasicTabComponent,
    TruespeedSetupAdvanceTabComponent
  ],
  providers: [TruespeedSetupService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TruespeedTestModule {}
